import { Layout } from 'src/components/layout/layout';
import Component from 'src/components/DescriptionLocation';

const DescriptionLocation = () => {
    return (
        <Layout>
            <Component />
        </Layout>
    );
};

export default DescriptionLocation;
